module.exports = __webpack_public_path__ + "img/battery-charging.73f5ee2a.svg";